import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook do sprawdzania statusu aktywności konta użytkownika
 * @returns {Object} { isActive, isLoading, error }
 */
export function useUserStatus() {
  const [isActive, setIsActive] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkUserStatus();
  }, []);

  const checkUserStatus = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setIsActive(false);
        setIsLoading(false);
        return;
      }

      // Pobierz status z public.users
      const { data: profile, error: profileError } = await supabase
        .from('users')
        .select('is_active')
        .eq('id', user.id)
        .single();

      if (profileError) {
        throw profileError;
      }

      // is_active może być null dla starych użytkowników, traktuj jako true
      setIsActive(profile?.is_active !== false);
    } catch (err) {
      console.error('Error checking user status:', err);
      setError(err.message);
      // W przypadku błędu, zakładamy że konto jest aktywne (fail-safe)
      setIsActive(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { isActive, isLoading, error, refetch: checkUserStatus };
}







